import React, { ChangeEvent, FormEvent, useState } from "react";
import {
  TextField,
  Container,
  Grid,
  Typography,
  CssBaseline,
  Box,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoginData } from "../../types/loginData";
import { login } from "../../api/authApi";

const styles = {
  input: {
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#303030",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 3,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#303030",
    },
  },
  button: {
    backgroundColor: "#303030",
    borderRadius: 2,
    fontWeight: "bold",
    letterSpacing: 1,
    height: 45,
    marginTop: 2,
    "&:hover": {
      backgroundColor: "#454545",
    },
    "&:focus": {
      backgroundColor: "#454545",
    },
  },
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState<LoginData>({
    login_usuario: "",
    password: "",
    aplicacao: "Backoffice",
  });

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLoginData({ ...loginData, [event.target.name]: event.target.value });
  };

  const handleLogin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await login(loginData);
      localStorage.setItem("token", response.token);
      localStorage.setItem("id_empresa", response.id_empresa);
      localStorage.setItem("userData", JSON.stringify(response));
      toast.success("Logado com sucesso!");

      setTimeout(() => {
        navigate("/dashboard");
      }, 800);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error(error.message);
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: "100vh",
          justifyContent: "center",
        }}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12} textAlign="center">
            <img src="../../logoStaff.png" alt="Staff 360" width={350} />
          </Grid>
          <Grid item xs={12}>
            <Typography
              component="h1"
              variant="h5"
              fontWeight="bold"
              textAlign="center"
            >
              Bem-vindo(a) <br /> Gestão
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box component="form" noValidate onSubmit={handleLogin}>
              <TextField
                margin="normal"
                fullWidth
                id="login_usuario"
                label="Usuário"
                name="login_usuario"
                autoComplete="email"
                autoFocus
                value={loginData.login_usuario}
                onChange={handleInputChange}
                sx={styles.input}
              />
              <TextField
                margin="normal"
                fullWidth
                name="password"
                label="Senha"
                type="password"
                value={loginData.password}
                onChange={handleInputChange}
                sx={styles.input}
              />
              <LoadingButton
                type="submit"
                fullWidth
                variant="contained"
                sx={styles.button}
              >
                Entrar
              </LoadingButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Login;
